import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const testimonials = [
  {
    quote:
      "I've worked with 6 marketing agencies in 9 years. CGoeight is the only one that actually moved the needle. We hit a 412% ROAS in month one. My GSM was speechless.",
    name: 'Marcus T.',
    title: 'General Sales Manager',
    company: "Arizona's #1 Porsche Dealership",
    avatar: 'https://public.readdy.ai/ai/img_res/81c850f900e8dd4652d561add47ee038.jpg',
  },
  {
    quote:
      "In 21 days they drove 1.2 million views to our listings. We closed $4.1M in new listings off that campaign alone. They operate at a different level.",
    name: 'Stephanie M.',
    title: 'Founder & Principal Broker',
    company: 'Meridian Luxury Properties',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20confident%20real%20estate%20businesswoman%2040s%20blazer%20clean%20neutral%20background%20premium%20corporate%20portrait%20sharp%20modern%20look&width=80&height=80&seq=t2&orientation=squarish',
  },
  {
    quote:
      "Our cost per case dropped from $800 to $87. That's not a typo. In 45 days, 63 qualified cases. I genuinely don't understand how they do it.",
    name: 'David R.',
    title: 'Managing Partner',
    company: 'Rivas & Associates Law Group',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20confident%20male%20attorney%2050s%20dark%20suit%20law%20firm%20executive%20clean%20neutral%20gray%20background%20premium%20corporate%20portrait%20sharp%20distinguished&width=80&height=80&seq=t3&orientation=squarish',
  },
  {
    quote:
      "We went from struggling to sell 200 tickets to 220,000 sold in 60 days. The AI targeting is genuinely scary-good. CGoeight made us a household name.",
    name: 'Jordan K.',
    title: 'CEO',
    company: 'Pulse Entertainment Group',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20young%20black%20entertainment%20executive%20CEO%20confident%20casual%20blazer%20dark%20background%20high%20contrast%20modern%20editorial%20portrait&width=80&height=80&seq=t4&orientation=squarish',
  },
  {
    quote:
      "Every single campaign they've run has beaten our internal projections. I stopped second-guessing their strategy after month two. The results speak.",
    name: 'Lisa C.',
    title: 'Marketing Director',
    company: 'SoCal Luxury Auto Group',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20female%20marketing%20director%20elegant%20business%20woman%2030s%20minimal%20background%20high%20contrast%20sharp%20corporate%20portrait%20confident%20look&width=80&height=80&seq=t5&orientation=squarish',
  },
];

export default function Testimonials() {
  const ref = useScrollAnimation();

  return (
    <section className="bg-black py-24 md:py-32 border-t border-white/5">
      <div ref={ref} className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16 fade-in-up">
          <p className="text-electric-blue text-xs font-semibold tracking-widest uppercase mb-4">
            Client Testimonials
          </p>
          <h2 className="font-display font-bold text-white leading-tight"
            style={{ fontSize: 'clamp(2rem, 3.5vw, 3rem)' }}
          >
            Straight From the Clients.
          </h2>
        </div>

        {/* Top row: 3 cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-5">
          {testimonials.slice(0, 3).map((t, i) => (
            <TestimonialCard key={t.name} testimonial={t} delay={i * 0.1} />
          ))}
        </div>

        {/* Bottom row: 2 cards centered */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:max-w-4xl md:mx-auto">
          {testimonials.slice(3).map((t, i) => (
            <TestimonialCard key={t.name} testimonial={t} delay={(i + 3) * 0.1} />
          ))}
        </div>
      </div>
    </section>
  );
}

interface TestimonialCardProps {
  testimonial: typeof testimonials[0];
  delay: number;
}

function TestimonialCard({ testimonial, delay }: TestimonialCardProps) {
  return (
    <div
      className="fade-in-up group bg-dark-card border border-dark-border rounded-lg p-7 hover:border-white/10 transition-all duration-300"
      style={{ transitionDelay: `${delay}s` }}
    >
      {/* Quote mark */}
      <div className="text-electric-blue/20 font-display text-5xl leading-none mb-4 font-bold">&ldquo;</div>

      {/* Quote */}
      <p className="text-white/70 text-sm leading-relaxed mb-6 italic">
        {testimonial.quote}
      </p>

      {/* Author */}
      <div className="flex items-center gap-3 pt-4 border-t border-white/5">
        <div className="w-10 h-10 flex-shrink-0 rounded-full overflow-hidden bg-white/5">
          <img
            src={testimonial.avatar}
            alt={testimonial.name}
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div>
          <div className="text-white font-semibold text-sm">{testimonial.name}</div>
          <div className="text-white/35 text-xs">{testimonial.title} · {testimonial.company}</div>
        </div>
      </div>
    </div>
  );
}
